module.exports = __webpack_public_path__ + "media/images/common/gt-50e477a4bcdd956b6cc7140a5a3ed030.gif";